import styled from 'styled-components';

export default styled.div`
	display: flex;
	gap: var(--spacing-medium);
	justify-content: center;

	hr {
		--hr-color: var(--neutrals-700);
	}
`;
